import styled from 'styled-components';

// flex: 1 + min-height: 0 + overflow-y: auto = the panel becomes the single
// scroll context for the inspector. Comments and Edits stack naturally; if
// the total exceeds the viewport, this container scrolls.
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow-y: auto;

	/* Align the collapsible-section headers (chevron + label) with the element-
	   name area above. CollapsibleSection's Header is a button rendered as a
	   direct child of this Container; padding it left here gives the chevron
	   the same gutter that HeaderBase has, without modifying the shared widget. */
	& > button {
		padding-left: 12px;
	}
`;

export const HeaderBase = styled.div`
	padding-left: 12px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: transparent;
	padding-top: 18px;
	padding-bottom: 12px;
`;

export const ElementName = styled.div`
	font-size: 16px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const DsComponentName = styled.div`
	font-size: 13px;
	font-family: 'JetBrains Mono', monospace;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 8px;
`;

// Wrapper for Comments inside the CollapsibleSection body. No height
// constraint — Comments sizes to its content and the outer Container's
// overflow handles scrolling for the whole panel.
export const CommentsWrapper = styled.div`
	display: flex;
`;

// Section content padding for Edits — tight gap between Field cards reads as
// a connected stack of properties rather than disconnected blocks.
export const EditsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 12px;
`;
